import { Plan2PlateDrawer, Plan2PlateDrawerHeader } from "./Plan2PlateDrawer";
import React from "react";
import { PurchaseEditor } from "./PurchaseEditor";
import { Purchase } from "../data/purchase";
import Food from "../data/food";

export function EditPurchaseDrawer(props: {
  onClose: () => void;
  open: boolean;
  onSubmit: (p: Purchase) => void | Promise<void>;
  purchase?: Purchase;
  food?: Food;
}) {
  return props.purchase && props.food ? (
    <Plan2PlateDrawer
      onClose={props.onClose}
      open={props.open}
      header={<Plan2PlateDrawerHeader heading={"Kaufprodukt bearbeiten"} />}
      body={
        <PurchaseEditor
          initialPurchase={props.purchase}
          isCreate={false}
          food={props.food}
          afterSave={(updatedPurchase: Purchase) => {
            props.onClose();
            props.onSubmit(updatedPurchase);
          }}
        />
      }
    />
  ) : (
    <></>
  );
}
